import { useEffect } from 'react';
import { Keyboard } from '@capacitor/keyboard';
import { isNative } from '@/domains/shared/utils/native';

export function useKeyboardDismiss() {
  useEffect(() => {
    if (!isNative()) return;

    void Keyboard.setAccessoryBarVisible({ isVisible: true });

    const listener = Keyboard.addListener('keyboardWillHide', () => {
      const active = document.activeElement;
      if (
        active instanceof HTMLInputElement ||
        active instanceof HTMLTextAreaElement
      ) {
        active.blur();
      }
    });

    return () => {
      void listener.then((handle) => handle.remove());
    };
  }, []);
}
